"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("./styles");
exports.Typography = (0, react_1.forwardRef)((props, ref) => {
    const { size, variant, ...rest } = props;
    const defaultVariant = variant || 'body';
    let defaultSize = size || 'normal';
    let defaultTag = 'p';
    switch (defaultVariant) {
        case 'highlight':
            defaultSize = size || 'lg';
            break;
        case 'heading':
            defaultSize = size || 'h1';
            break;
        case 'button':
            defaultSize = size || 'normal';
            break;
        default:
            defaultSize = size || 'normal';
            break;
    }
    if (defaultVariant === 'heading') {
        switch (defaultSize) {
            case 'h1':
                defaultTag = 'h1';
                break;
            case 'h2':
                defaultTag = 'h2';
                break;
            case 'h3':
                defaultTag = 'h3';
                break;
            case 'h4':
                defaultTag = 'h4';
                break;
            case 'h5':
                defaultTag = 'h5';
                break;
            case 'h6':
                defaultTag = 'h6';
                break;
            default:
                defaultTag = 'p';
                break;
        }
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledTypography, { "data-testid": "typography", ref: ref, variant: defaultVariant, size: defaultSize, as: defaultTag, ...rest }));
});
exports.Typography.displayName = 'Typography';
exports.default = exports.Typography;
//# sourceMappingURL=typography.js.map